const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-textarea ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    name: String,
    label: String,
    value: String,
    rows: { type: Number, default: 4 },
    placeholder: String,
    hint: String,
    error: String,
    maxlength: Number,
    autogrow: Boolean,
  }

  onMount() {
    const area = this.state.area
    if (this.props.value) area.value = this.props.value
    if (this.props.maxlength) area.maxLength = this.props.maxlength
    if (this.props.autogrow) {
      this.on(area, 'input', () => this.fit())
      this.fit()
    }
  }

  // A new `value` from the parent replaces the text, as in ui-input.
  onRefresh(props, changed) {
    if ('value' in changed) this.setValue(props.value || '')
  }

  value() {
    return this.state.area?.value ?? ''
  }

  setValue(text) {
    if (this.state.area) this.state.area.value = text
    this.fit()
  }

  // Measured from `auto` so the box also shrinks; `rows` stays the minimum.
  fit() {
    const area = this.state.area
    if (!area || !this.props.autogrow) return
    area.style.height = 'auto'
    if (area.scrollHeight) area.style.height = `${area.scrollHeight + area.offsetHeight - area.clientHeight}px`
  }

  CSS = `:fez {
display:block;label{display:grid;gap:6px}.label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--color-text)}textarea{width:100%;padding:var(--space-3);border:1px solid var(--color-border-strong);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text);font:inherit;font-size:var(--text-md);resize:vertical;transition:border-color var(--duration-fast) var(--ease),box-shadow var(--duration-fast) var(--ease);&:focus{outline:0;border-color:var(--color-accent);box-shadow:0 0 0 3px var(--color-accent-soft)}&::placeholder{color:var(--color-text-subtle)}}.autogrow textarea{max-height:50vh;resize:none;overflow-y:auto}.invalid textarea{border-color:var(--color-danger)}.hint,.error{font-size:var(--text-xs);color:var(--color-text-muted)}.error{color:var(--color-danger);font-weight:var(--weight-medium)}
}`

  HTML = `<label class:invalid={props.error} class:autogrow={props.autogrow}>
{#if props.label}
<span class="label">{props.label}</span>
{/if}
<textarea fez:this="area" name={props.name} rows={props.rows} placeholder={props.placeholder || ''} aria-label={props.label || props.placeholder || ''} spellcheck="true"></textarea>
{#if props.error}
<span class="error" role="alert">{props.error}</span>
{:else if props.hint}
<span class="hint">{props.hint}</span>
{/if}
</label>`
};
}

Fez('ui-textarea', __fez_component_0);

export default __fez_component_0;
